import React, { useCallback } from 'react';

import { useFormContext } from 'react-hook-form';

import { getRichTextContent } from 'utils/richTextUtils';
import { z } from 'zod';

import { AcAdvancedTextInput } from 'components/AcAdvancedTextInput/AcAdvancedInput';
import { FormControl, FormField, FormItem, FormMessage } from 'components/ui';

import { templateStudioSchema } from '../../../validation-schema';

export const TemplateStudioRichTextForm: React.FC = () => {
  const { control, watch } =
    useFormContext<z.infer<typeof templateStudioSchema>>();

  const buildRichTextValue = useCallback((newText: string) => {
    const currentRichText = watch('richText');
    return { ...currentRichText, text: newText };
  }, [watch]);

  const handleProgrammaticChange = useCallback((newText: string, currentText: string | undefined, onChange: Function) => {
    if (getRichTextContent(currentText) === getRichTextContent(newText)) {
      return;
    };
    onChange(buildRichTextValue(newText));
  }, [buildRichTextValue]);

  const handleUserChange = useCallback((newText: string, onChange: Function) => {
    onChange(buildRichTextValue(newText));
  }, [buildRichTextValue]);

  return (
    <FormField
      control={control}
      name="richText"
      render={({ field: { value, onChange } }) => (
        <FormItem>
          <FormControl>
            <AcAdvancedTextInput
              value={value?.text || ''}
              setValue={(newText) =>
                handleProgrammaticChange(newText, value?.text, onChange)
              }
              onUserContentChange={(newText) =>
                handleUserChange(newText, onChange)
              }
              error={false}
              enableColorPicker={true}
              fontColor={value?.fontColor || 'rgb(0, 0, 0)'}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
